import { render, staticRenderFns } from "./LoginWrapDlivewall.vue?vue&type=template&id=13e48bf1&scoped=true"
import script from "./LoginWrapDlivewall.vue?vue&type=script&lang=js"
export * from "./LoginWrapDlivewall.vue?vue&type=script&lang=js"
import style0 from "./LoginWrapDlivewall.vue?vue&type=style&index=0&id=13e48bf1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e48bf1",
  null
  
)

export default component.exports